export default __webpack_public_path__ + "static/media/04.bcf7858d.png";